import { useEffect, useRef } from "react";
import { getInitialValues } from "./ProductDetails.validation";
import { useAuth } from "lib/hooks/useAuth";
import { useFormContext } from "lib/hooks/useFormContext";

const fields = ["firstName", "lastName", "email", "phoneNumber"] as const;

export const PopulateFormOnLogin = (): null => {
  const { user } = useAuth();
  const userRef = useRef(user);
  const { setValue, getValues } =
    useFormContext<ReturnType<typeof getInitialValues>>();

  useEffect(() => {
    // on user sign in
    if (user && !userRef.current) {
      const contactValue = getValues("contact");

      for (const field of fields) {
        setValue(
          `contact.${field}`,
          field === "email" ? user[field] : contactValue[field] || user[field],
        );
      }
    }

    userRef.current = user;
  }, [user]);

  return null;
};
